import React, { useEffect, useState } from "react";
import NoDataFound from "../../../Extra/NoDataFound";
import { getCurrentFY } from "../../../Utilitie";
import AnimatedDisplay from "../../../CHARTS/AnimatedDisplay";
const tHead = ["financial year", "previous year", "Current year", "target"];
const keysToSum = [
  // "total_ACT_WEIGHT",
  // "total_CH_DISPATCH",
  // "total_CH_WEIGHT",
  // "total_CNSR",
  // "total_FREIGHT",
  // "total_TGT_CH_WEIGHT",
  // "total_TGT_WAGON",
  // "total_WAGON",
  "ACT_WEIGHT",
  "CH_DISPATCH",
  "CH_WEIGHT",
  "FREIGHT",
  "TGT_CH_WEIGHT",
  "TGT_WAGON",
  "WAGON",
];
const SummeryData = ({ data }) => {
  const [sumData, setSumData] = useState(null);
  const groupNestedData = (data, keysToSum) => {
    const result = {};

    data.forEach((yearObj) => {
      const fy = yearObj.F_YEAR;
      if (!result[fy]) result[fy] = {};

      yearObj.commodities_data.forEach((group) => {
        group.group_commodities_data.forEach((subGroup) => {
          subGroup.sub_commodities_data.forEach((commodityObj) => {
            const commodity = commodityObj.COMMODITY;
            if (!result[fy][commodity]) {
              result[fy][commodity] = {};
              keysToSum.forEach((key) => (result[fy][commodity][key] = 0));
            }

            // Track unique FROM_STN per A_MONTH to avoid duplicates in TGT_* sums
            const monthFromStnTracker = {};

            commodityObj.months_data.forEach((monthData) => {
              const month = monthData.A_MONTH;

              monthData.data.forEach((record) => {
                // Regular key summation
                keysToSum.forEach((key) => {
                  if (key !== "TGT_WAGON" && key !== "TGT_CH_WEIGHT") {
                    const val = parseFloat(record[key]) || 0;
                    result[fy][commodity][key] += val;
                  }
                });

                // Deduplicated target logic (by FROM_STN per month)
                const fromStn = record.FROM_STN;
                const monthKey = `${month}_${fromStn}`;

                if (!monthFromStnTracker[monthKey]) {
                  monthFromStnTracker[monthKey] = true;

                  // Sum TGT_WAGON and TGT_CH_WEIGHT only once per FROM_STN per month
                  result[fy][commodity].TGT_WAGON +=
                    parseFloat(record.TGT_WAGON) || 0;
                  result[fy][commodity].TGT_CH_WEIGHT +=
                    parseFloat(record.TGT_CH_WEIGHT) || 0;
                }
              });
            });
          });
        });
      });
    });

    return result;
  };
  function sumByTopLevelKey(data) {
    const result = {};

    for (const topKey in data) {
      const sumObj = {};

      const nestedObjects = data[topKey];
      for (const innerKey in nestedObjects) {
        const obj = nestedObjects[innerKey];

        for (const prop in obj) {
          if (!sumObj[prop]) {
            sumObj[prop] = 0;
          }
          sumObj[prop] += obj[prop];
        }
      }

      result[topKey] = sumObj;
    }

    return result;
  }
  useEffect(() => {
    if (data !== null && data?.length > 0) {
      // const filteredData = data?.total?.filter(
      //   (item) => item?.F_YEAR === curentFy && item.COMMODITY === "CEMT"
      // );
      const tempData = groupNestedData(data, keysToSum);
      const sortedData = Object.fromEntries(
        Object.entries(tempData).sort(([keyA], [keyB]) => {
          const yearA = parseInt(keyA.split("_")[0]);
          const yearB = parseInt(keyB.split("_")[0]);
          return yearA - yearB;
        })
      );

      const sumobj = sumByTopLevelKey(sortedData);

      setSumData(sumobj);
    }
  }, [data]);
  return (
    <div className="">
      <div className="row">
        <div className="bg-dark text-white">
          <h6 className="p-1">
            {" "}
            Summary
            <b style={{ color: "#b3b2b2ff", fontSize: "15px" }}>
              {" "}
              (month wise)
            </b>
          </h6>
        </div>
        {sumData ? (
          <div className="table-responsive mt-3" style={{ fontSize: "12px" }}>
            <table className="table table-hover table-striped text-center">
              <thead style={{ fontSize: "15px" }}>
                <tr>
                  <th>Financial year</th>
                  <th>Wagon</th>
                  <th>Target</th>
                </tr>
              </thead>{" "}
              <tbody>
                {Object.entries(sumData).map(([key, value], ind) => {
                  return (
                    <tr key={ind}>
                      <th>{key}</th>
                      <td className="">
                        {" "}
                        <AnimatedDisplay
                          value={sumData[key].WAGON.toFixed(2)}
                          fixedWidth="200px"
                        />
                      </td>
                      <td>
                        {" "}
                        <AnimatedDisplay
                          value={sumData[key].TGT_WAGON.toFixed(2)}
                          fixedWidth="200px"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <table className="table table-hover table-striped">
              <thead style={{ fontSize: "15px" }}>
                <tr>
                  <th>Financial year</th>
                  <th>Ch weight</th>
                  <th>Target</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(sumData).map(([key, value], ind) => {
                  return (
                    <tr key={ind}>
                      <th>{key}</th>

                      <td>
                        {" "}
                        <AnimatedDisplay
                          value={sumData[key].CH_WEIGHT.toFixed(2)}
                          fixedWidth="200px"
                        />
                      </td>
                      <td>
                        {" "}
                        <AnimatedDisplay
                          value={sumData[key].TGT_CH_WEIGHT.toFixed(2)}
                          fixedWidth="200px"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>{" "}
    </div>
  );
};
export default SummeryData;
